(() => {
  if (window.__chromePrelaunchInitialized) return;
  window.__chromePrelaunchInitialized = true;
  const states = new WeakMap();
  const init = scope => {
    scope.querySelectorAll('.chrome-launch').forEach(root => {
      if (states.has(root)) return;
      const abort = new AbortController();
      states.set(root, abort);
      const signal = abort.signal;
      const query = matchMedia('(max-width: 749px)');
      const video = root.querySelector('video');
      const updatePoster = () => {
        video.poster = query.matches ? root.dataset.mobilePoster : root.dataset.desktopPoster;
      };
      updatePoster();
      query.addEventListener('change', updatePoster, {signal});
      const details = root.querySelector('.launch-newsletter');
      const email = root.querySelector('input[type="email"]');
      details.addEventListener('toggle', () => {
        if (details.open && email && !root.querySelector('[data-newsletter-result]')) {
          email.focus({preventScroll:true});
        }
      }, {signal});
      root.querySelector('form').addEventListener('invalid', () => {
        details.open = true;
      }, {capture:true,signal});
      const result = root.querySelector('[data-newsletter-result]');
      if (result) {
        details.open = true;
        result.focus({preventScroll:true});
      }
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.chrome-launch').forEach(root => {
      states.get(root)?.abort();
      states.delete(root);
    });
  });
})();
